import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';

import { Button } from 'src/registry/ui/Button';
import { DropdownMenuTrigger, DropdownMenu, DropdownMenuContent } from 'src/registry/ui/DropdownMenu';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import { ICON_MAP } from 'src/utils/constants';
import { cn } from 'src/utils/shadcn';

type Props = {
    selectedDate: dayjs.Dayjs;
    setSelectedDate: (d: dayjs.Dayjs) => void;
};
export default function MonthPicker({ selectedDate, setSelectedDate }: Props) {
    const { months, years } = React.useMemo(() => {
        const years = Array.from({ length: 20 }, (_, i) => dayjs().year() - i);
        const months = Array.from({ length: 12 }, (_, i) => dayjs().set('month', i).format('MMM'));

        return {
            years,
            months,
        };
    }, []);

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="outline">
                        <FontAwesomeIcon icon={ICON_MAP.CALENDAR} />
                        {selectedDate.format('MMM YYYY')}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="flex flex-col gap-2">
                    <Select
                        onValueChange={(value) => setSelectedDate(selectedDate.set('year', Number(value)))}
                        value={selectedDate.year().toString()}
                    >
                        <SelectTrigger className="h-8">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            {years.map((year) => (
                                <SelectItem key={year} value={year.toString()}>
                                    {year}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                    <div className="grid grid-cols-3 gap-y-2">
                        {months.map((month, index) => {
                            const isSelected = selectedDate.month() === index;

                            return (
                                <Button
                                    variant="ghost"
                                    className={cn(
                                        'h-9 w-9 p-0 font-normal aria-selected:opacity-100',
                                        isSelected && 'bg-primary-600 hover:bg-primary-700 text-white',
                                    )}
                                    key={month}
                                    onClick={() => setSelectedDate(selectedDate.set('month', index))}
                                >
                                    {month}
                                </Button>
                            );
                        })}
                    </div>
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
}
